import { ProfileErrorCodes } from '@diritto/common/account/constants/profile.error-codes.constants';

export const ProfileToastMessage = {
  [ProfileErrorCodes.NicknameAlreadyExists]: '중복된 필명이에요. 다른 필명을 사용해주세요.',
  [ProfileErrorCodes.NicknameReserved]:
    '이 필명은 이미 기성작가로 등록되어 있어요. 이 필명의 출간이력을 가진 작가가 요청할 경우, 필명에 대한 소유권이 이전될 수 있어요.',
  [ProfileErrorCodes.OverUserProfileCount]: '프로필은 최대 5개까지 만들 수 있어요.',
  [ProfileErrorCodes.NicknameRestricted]: '사용할 수 없는 필명이에요. 다른 필명을 사용해주세요.',
};

export const EMPTY_PROFILE_TEXT = '삭제된 프로필';
